import { ReactNode } from 'react';
import { getHealthColor } from './utils';

interface HealthIndicatorProps {
	health: number;
}

const HealthIndicator = ({ health }: HealthIndicatorProps) => {
	const getSegments = (value: number) => {
		const segments: ReactNode[] = [];
		const totalSegments = 10;
		const filledSegments = Math.floor(value / 10);

		for (let i = 0; i < totalSegments; i++) {
			let color = getHealthColor(value)+'30';

			if (i < filledSegments) {
				color = getHealthColor(value);
			}

			segments.push(
				<div key={i} className="w-2 h-4 rounded-sm" style={{ backgroundColor: color }} />,
			);
		}

		return segments;
	};

	if (health === 0) {
		return (
			<div className="flex space-x-1">
				{Array.from({ length: 10 }, (_, i) => (
					<div key={i} className="w-2 h-4 rounded-sm bg-gray-200" />
				))}
			</div>
		);
	}

	return <div className="flex space-x-1">{getSegments(health)}</div>;
};

export default HealthIndicator;
